export type GameControlPhase =
  | 'key9_in_progress'
  | 'key9_practice'
  | 'key9_unlocked'
  | 'key9_missed'
  | 'key9_practice_complete'
  | 'full_in_progress'
  | 'full_done'
  | 'active';

export type GameControlAction = {
  id: 'undo' | 'erase' | 'notes' | 'hint';
  label: string;
  icon: string;
};

export type FullSecondaryAction = {
  id: 'view_result' | 'restart_key9';
  label: string;
};

export type GameControlState = {
  visible: boolean;
  mode: 'hidden' | 'full';
  placement: 'hidden' | 'above_number_pad';
  secondaryActionsPlacement: 'hidden' | 'below_number_pad_flow';
  layout?: {
    instructionY: number;
    toolbarTopY: number;
    numberPadY: number;
  };
  actions: GameControlAction[];
  secondaryActions: FullSecondaryAction[];
};

export const FULL_SUDOKU_INPUT_LAYOUT = {
  instructionY: 414,
  toolbarTopY: 428,
  numberPadY: 506
};

export function canContinueSudokuFromSceneState(mode: 'key9' | 'full', completed: boolean): boolean {
  return mode === 'key9' && completed;
}

const FULL_ACTIONS: GameControlAction[] = [
  { id: 'undo', label: 'Undo', icon: '↶' },
  { id: 'erase', label: 'Erase', icon: '⌫' },
  { id: 'notes', label: 'Notes', icon: '✎' },
  { id: 'hint', label: 'Hint', icon: '?' }
];

const FULL_SECONDARY_ACTIONS: FullSecondaryAction[] = [
  { id: 'view_result', label: 'View Result' },
  { id: 'restart_key9', label: 'Restart Key9' }
];

export function getGameControlState(phase: GameControlPhase): GameControlState {
  if (phase === 'full_in_progress') {
    return {
      visible: true,
      mode: 'full',
      placement: 'above_number_pad',
      secondaryActionsPlacement: 'below_number_pad_flow',
      layout: FULL_SUDOKU_INPUT_LAYOUT,
      actions: FULL_ACTIONS,
      secondaryActions: FULL_SECONDARY_ACTIONS
    };
  }

  return {
    visible: false,
    mode: 'hidden',
    placement: 'hidden',
    secondaryActionsPlacement: 'hidden',
    actions: [],
    secondaryActions: []
  };
}
